<template>
  <div>
    <NavPage></NavPage>
    <div class="content">
      <SlideShow></SlideShow>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="公司简介" name="first"></el-tab-pane>
      <el-tab-pane label="团队简介" name="second"></el-tab-pane>
      <el-tab-pane label="企业文化" name="third"></el-tab-pane>
      <el-tab-pane label="公司资质" name="fourth"></el-tab-pane>
      <el-tab-pane label="专家团队" name="fifth"></el-tab-pane>
    </el-tabs>
    <div class="container">
      <p v-show="activeName == 'first'">
        &nbsp; &nbsp;&nbsp;&nbsp; 成都东迈电子科技有限责任公司（中文简称东迈电科，英文简称DMETC）成立于2006年，注册资金3000万元人民币，
        公司的业务范围主要有智慧园区、 智慧校园、系统集成、电子与智能化工程、软件定制开发等。公司具有实用新型专利技术多项；计算机软件著作权多项。
        公司具有专业的智能化工程建设能力；具有智慧园区、 智慧校园等项目顶层设计能力；具有物联网硬件研发能力；目前完成城市级三维CIM平台建模项目一项，
        智慧校园整体交付项目一项。公司立足于四川省成都市，面向全国提供服务。 公司在四川、新疆、江苏、广东等地开展系统集成、软件开发及建筑智能化业务，
        并在新疆乌鲁木齐、阿克苏、塔城、江苏南京、广东广州成立了分支服务机构。
        <br />
        &nbsp; &nbsp;&nbsp;&nbsp; 公司以“互惠互利，共同成长，持续发展，共创未来”为核心价值观，坚持品质信誉第一，不断创新奋进，竭诚为客户提供一流的建筑智能、系统集成、软件开发、 
        物联网硬件开发等综合解决方案和快捷优质的售后服务。公司自成立近20年来，项目的建设受到业主的一致好评，我公司将再接再厉，努力奋斗，与合作伙伴共成长。
      </p>
      <p v-show="activeName == 'second'">
        &nbsp; &nbsp;&nbsp;&nbsp; 公司现有团队成员50人，其中，80%大专以上学历，40%本科以上学历。其中，高级工程师2人，一级建造师4人，二级建造师6人，FLUKE认证综合布线工程师3人，
        通讯工程师4人，智能楼宇工程师5人，系统集成工程师5人。公司聘西南科技大学教授陈昌洪博士担任战略管理顾问；聘美国长青藤宾夕法尼亚大学张帆博士担任产品技术总监。
        我公司设计人员及工程项目管理人员至少五年以年行业经验。经过十五年的行业沉淀，我公司已经完成优秀建筑智能化企业及软件企业人才储备。我公司团队具有独立的项目实施能力，
        除了自身独立承接项目以外，还是中国兵器成都西物信安智能系统有限公司、中科院成都信息技术股份有限公司、高斯贝尔数码科技股份有限公司等行业央企或上市公司的项目外包实施单位。
        我们深知，团队打造对于企业建设相当重要，团队的综合实力决定了公司的总体水平，优秀的团队才能建设优质的项目。
      </p>
      <div v-show="activeName == 'third'">
        <h3>公司价值观：</h3>
        <p>互惠互利&nbsp;&nbsp; 共同成长&nbsp;&nbsp; 持续发展&nbsp;&nbsp; 共创未来</p>
        <h3>公司精神：</h3>
        <p>忠诚守信&nbsp;&nbsp; 创新奋进&nbsp;&nbsp; 不断超越&nbsp;&nbsp; 追求卓越</p>
        <h3>公司理念：</h3>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp; 以专业、精炼的品质，提供优秀的建筑智能化、系统集成、软硬件开发综合解决方案，为客户创造价值;
          以职业、事业为支撑，为员工搭建广阔发展舞台，实现员工愿望和梦想。
        </p>
        <h3>公司愿景：</h3>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp; 专注于行业发展应用方向，在细分领域精耕力作，以产品优质、服务优秀和完美的整体解决方案为核心竞争力，
          争做行业领域先进。不断进取，持之以恒，成为全国一流的建筑智能化、系统集成企业。
        </p>
      </div>
      <div v-show="activeName == 'fourth'">
        <div class="photo">
          <h3>营业执照 :</h3>
          <img src="@/assets/img/businessLicense.png" alt />
        </div>
        <div>
          <h3>知识产权 :</h3>
          <img src="@/assets/img/intellectual.jpg" alt />
        </div>
        <div>
          <h3>专利证书 :</h3>
          <img src="@/assets/img/lettersPatent.jpg" alt />
        </div>
      </div>
      <div v-show="activeName == 'fifth'">
        <div class="people">
          <img src="@/assets/img/chenhongchang.jpg" alt />
          <p>战略管理顾问</p>
        </div>
        <p>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  陈昌洪，教授，管理学博士，硕士生导师，西南科技大学经济管理学院教师。曾在政府部门任职，作为负责人和主研人参与了20余项科研项目，其中国家社会科学基金项目2项、
          省（部）级科研课题7项；在国内外学术刊物上发表论文40余篇，出版专著2部，主编和参编教材4部。主要研究方向为战略管理、市场营销和农业经济管理，现担任国内知名上市公司战略管理顾问，同时任我公司战略管理顾问。
        </p>
        <div class="people">
          <img src="@/assets/img/zhangfan.jpg" alt />
          <p>技术总监</p>
        </div>
        <p>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  张帆，美国常青藤宾夕法尼亚大学机器人技术博士，重庆大学工商管理博士，美国常青藤电子工程、机械工程双硕士，现任重庆大学城市科技学院特聘教授、IEEE美国电气电子工程师协会会员、
          ASME美国机械工程师学会会员、成都东迈电子科技有限责任公司技术总监。参与开发过美国MicroStrategy智能大数据软件、DARPA美国国防部高级研究局军用机器人、
          国防科工委水下仿生机器人等多个机器人、人工智能项目。先后获得过美国常青藤Research Fellowship全额奖学金、ASME美国机械工程师学会最佳论文奖、拥有3项机器人技术专利，
          和多篇关于机器人协同控制技术的SCI、EI国际学术期刊论文。主持开发了杭州市城市垃圾分类回收平台、上海数字化农产品供应链等多个省、厅级重点物联网、大数据平台。
          担任我公司技术总监以来主持开发了新疆自治区公安厅维稳大数据平台、平安塔城CIM三维地理信息平台、智慧消防管理系统、智慧物联网管理平台、智慧校园、智慧城市统一身份认证软件等软件产品。
        </p>
      </div>
    </div>
    <FooterPage></FooterPage>
  </div>
</template>

<script>
import NavPage from "@/components/NavPage.vue";
import SlideShow from "@/components/SlideShow.vue";
import FooterPage from "@/components/FooterPage.vue";
export default {
  name: "CompanyPage",
  components: {
    NavPage,
    FooterPage,
    SlideShow
  },
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {}
};
</script>

<style  scoped>
.content {
  width: 1340px;
  margin: auto;
}
.slide img {
  width: 100%;
  height: 500px;
}
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  text-align: center;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__item {
  font-size: 20px;
  width: 150px;
  margin-top: 50px;
}
.container p {
  width: 80%;
  margin: auto;
  text-align: left;
  font-size: 18px;
  line-height: 50px;
}
.container h3 {
  text-align: left;
  width: 80%;
  margin: auto;
  padding: 10px;
}
::v-deep .el-tabs__nav-scroll {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.people p{
  margin: auto;
  text-align: center;
}
.photo img{
  width: 70%;
}
</style>